<template>
  <b-form class="registration" @submit="triggerCalculation">
    <b-form-group class="registration__input p-3">
      <p class="text-white">Entrez tous vos Prénoms de naissance.</p>
      <b-form-input
        v-model="firstNames"
        @keydown.enter="triggerCalculation"
        type="text"
        required
        placeholder="Entrez tous vos Prénoms de naissance uniquement"
      />

      <div class="input__error" v-if="!$v.firstNames.required">Le champ est requis.</div>
      <div class="input__error" v-if="!$v.firstNames.minLength">
        Vos prénoms doivent avoir au moins {{ $v.firstNames.$params.minLength.min }} caractères.
      </div>
      <div class="input__error" v-if="!$v.firstNames.maxLength">
        Vos prénoms doivent avoir un maximum de {{ $v.firstNames.$params.maxLength.min }} caractères.
      </div>

      <div class="border-top-primary-dark-dot mt-2 mb-2"></div>

      <p v-if="gender === 'male'" class="text-white">Entrez votre nom de famille.</p>
      <p v-else class="text-white">
        Entrez votre nom de famille (si vous êtes mariée, entrez <strong>uniquement votre nom de jeune fille</strong>).
      </p>

      <b-form-input
        v-model="lastName"
        @keydown.enter="triggerCalculation"
        type="text"
        required
        placeholder="Entrez votre nom de famille de naissance uniquement"
      />

      <div class="input__error" v-if="!$v.lastName.required">Le champ est requis.</div>
      <div class="input__error" v-if="!$v.lastName.minLength">
        Votre nom de famille doit avoir au moins {{ $v.lastName.$params.minLength.min }} caractères.
      </div>
      <div class="input__error" v-if="!$v.lastName.maxLength">
        Votre nom de famille doit avoir un maximum de {{ $v.lastName.$params.maxLength.min }} caractères.
      </div>

      <div class="text-right">
        <b-button @click="triggerCalculation" variant="success">Calculer Mon Nombre De La Destinée</b-button>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BButton } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import { calculateExpressionNumber } from "@/helpers/experiences";

export default {
  name: "FullName",
  mixins: [validationMixin],
  components: { BForm, BFormGroup, BFormInput, BButton },
  props: {
    gender: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    firstNames: null,
    lastName: null,

    errorMessage: null,
    hasSubmitError: false,
  }),
  methods: {
    triggerCalculation(e) {
      if (e) e.preventDefault();

      this.$v.$touch();
      if (this.$v.$invalid) return;

      const { firstNames, lastName } = this;
      const expression = calculateExpressionNumber({ firstNames, lastName });

      this.$emit("success", { expression, firstNames, lastName });
    },
  },
  validations: {
    firstNames: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(500),
    },
    lastName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(100),
    },
  },
};
</script>
